import { useQuery } from '@tanstack/react-query'
import { soundscapePositionsQueryOptions } from '@/entities/soundscape'
import { useSoundscapePlayer } from './player-store'

// Запуск режима с той точки, где сотрудник его бросил. Точки лежат на сервере,
// поэтому продолжение работает и на другой машине; неизвестный режим начинается
// с нуля. Все кнопки включения ходят сюда — иначе часть из них молча стартовала
// бы с начала.
export function useResumePlay() {
  const { data } = useQuery(soundscapePositionsQueryOptions)
  const { play, stop, playing, slug: current } = useSoundscapePlayer()

  const savedAt = (slug: string) => data?.find((p) => p.slug === slug)?.positionSeconds ?? 0

  return {
    play: (slug: string, title: string) => play(slug, title, savedAt(slug)),
    toggle: (slug: string, title: string) => {
      if (current === slug && playing) stop()
      else play(slug, title, savedAt(slug))
    },
  }
}
